import Config from '../../config';
import Filters from '../../view/module/schedule/launch.filters';
import Module from '../../core/module';
import ScheduleCalendarModule from './calendar';
import ScheduleTasksModule from './tasks';
import Schedules from '../../collection/schedules';
import ScheduleFormModule from './form';
import ScheduleTemplatesModule from './templates.list';

import { del } from '../../http/api';
import { ask, } from '../../utils/popups';
import { beginLock, endLock } from '../../loader';





export default Module.extend( {

    template: 'jst/module.schedule.list',

    url() {
        return `schedule/list`;
    },

    open() {
        if (!Config.privileges().includes( 'access_schedule' ))
            return Promise.reject( '403 Forbidden' );

        return this.options.schedules = new Schedules( [] ),
            this.filtersModel = new Filters.Model( this.state().filters ),
            this.fetch().then( () => 
                this.bind( this.filtersModel ) );
    },

    start() {
        return this;
    },

    stop() {
        return this;
    },

    serialize() {
        return {
            date: this.state().date,
        };
    },

    events: {

        'click .-toggle-monthly'() {
            this.trigger( ScheduleCalendarModule.TOGGLE_CALENDAR,
                // pass id only; schedule will be retrieved by /stats response
                this.state().scheduleId,
                this.state().time,
                this.state().month,
                this.state().date,
                this.state().filters );
        },

        'click .-toggle-daily'() {
            if (this.state().scheduleId)
                this.trigger( ScheduleTasksModule.REPLACE, 
                    // pass id only; schedule will be retrieved by /tasks response
                    this.state().scheduleId,
                    this.state().time,
                    this.state().month,
                    this.state().date,
                    this.state().filters );
            else
                this.trigger( ScheduleCalendarModule.OPEN_LAUNCHES_DAILY, 
                    this.state().month,
                    this.state().date,
                    this.state().filters );
        },

        'click .-new-schedule': function(/*{currentTarget}*/) {
            this.trigger( ScheduleFormModule.POPUP_NEW );
        },

    },

    [Module.event( ':schedule:edit' )]({ id }) {
        this.trigger( ScheduleFormModule.POPUP_EDIT,
            this.options.schedules.findWhere( { id: +id, } ) );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        return ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => beginLock( this ) )
            .then( () => this.fetch() )
            .then( () => {
                if (this.options.schedules.total > 0 && !this.options.schedules.length)
                    if (this.state().page > 1)
                        return this.setState( { page: this.state().page - 1, } ),
                            this.fetch();
            } )
            .then( () => Promise.all( [this.Schedules.render(), this.Paging.render()] ) )
            .then( () => endLock( this ), () => endLock( this ) )
            .then( () => this.navigated() );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        this.trigger( ScheduleTemplatesModule.POPUP,
            this.options.schedules.findWhere( { id: +id, } ) );
    },

    [Module.event( 'Filters:change' )](filters) {
        return this.setState( { filters, page: 1, } ),
            this.fetch()
                .then( () => Promise.all( [this.Schedules.render(), this.Paging.render()] ) )
                .then( () => this.navigated() );
    },

    [Module.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            beginLock( this ),
            this.fetch()
                .then( () => Promise.all( [this.Schedules.render(), this.Paging.render()] ) )
                .then( () => endLock( this ) )
                .then( () => this.navigated() );
    },

    fetch() {
        const
            { page } = this.state();

        return this.options.schedules.seq( {
            ...this.filtersModel.values(),
            limit: 12,
        }, page );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/schedule/list.js